// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__EligibilityIssuesLinkComponent__red{color:var(--gw-red-3)}.app__EligibilityIssuesLinkComponent__yellow{color:var(--gw-yellow-2)}", "",{"version":3,"sources":["webpack://./../common/wni/modules-react/wni-components-platform-react/components/EligibilityIssuesLinkComponent/EligibilityIssuesLinkComponent.module.scss"],"names":[],"mappings":"AAAA,0CACE,qBAAA,CAGF,6CACE,wBAAA","sourcesContent":[".red {\n  color: var(--gw-red-3)\n}\n\n.yellow {\n  color: var(--gw-yellow-2)\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"red": "app__EligibilityIssuesLinkComponent__red",
	"yellow": "app__EligibilityIssuesLinkComponent__yellow"
};
export default ___CSS_LOADER_EXPORT___;
